import { createFileRoute } from '@tanstack/react-router'
import Footer from '@/components/Footer'
import Header from '@/components/Header'

export const Route = createFileRoute('/terms')({
  component: TermsPage,
})

function TermsPage() {
  const lastUpdated = '1 March 2026'

  return (
    <div className="flex min-h-screen flex-col bg-neutral-50 dark:bg-neutral-950">
      <Header />
      <main
        id="main-content"
        className="mx-auto w-full max-w-4xl flex-1 px-4 py-10 md:px-8"
      >
        <article className="rounded-2xl border bg-white p-6 shadow-sm dark:border-neutral-800 dark:bg-neutral-900 md:p-8">
          <h1 className="text-3xl font-bold text-neutral-900 dark:text-neutral-100">
            Terms of service
          </h1>
          <p className="mt-2 text-sm text-neutral-500">
            Last updated: {lastUpdated}
          </p>

          <section className="mt-6 space-y-3 text-sm leading-7 text-neutral-700 dark:text-neutral-300">
            <p>
              BuildingRegs.app provides AI-assisted guidance for UK building
              regulations and related standards. You are responsible for
              reviewing citations and validating outputs against official
              documents before making project or legal decisions.
            </p>
            <p>
              Paid plans renew monthly unless canceled before the next billing
              date. You can manage your subscription from your dashboard at any
              time.
            </p>
            <p>
              To report account, billing, or content issues, contact
              support@buildingregs.app.
            </p>
          </section>
        </article>
      </main>
      <Footer />
    </div>
  )
}
